<div class="d-flex flex-column gap-3">
  <div class="d-flex flex-column gap-3">
    <span class="beneficiary-title mb-0" i18n>Personal Details</span>
    <div class="changes-container">
      <div class="changes-card">
        <span class="changes-title" i18n>Previous</span>
        <ng-container *ngIf="!(formattedPersonalChanges$ | async | previousNotApplicable); else notApplicable">
          <ng-container *ngFor="let change of (formattedPersonalChanges$ | async)?.previous">
            <app-submission-detail
              *ngIf="change.key !== 'socialInsuranceNumber'"
              [label]="change.label"
              [value]="change.value"
              [hasChanged]="change.hasChanged"
              [submissionState]="SubmissionStateEnum.Previous" />
            <app-sin-submission-detail
              *ngIf="change.key === 'socialInsuranceNumber'"
              [value]="change.value"
              label="Social Insurance Number"
              i18n-label
              [hasChanged]="change.hasChanged"
              [submissionState]="SubmissionStateEnum.Previous" />
          </ng-container>
        </ng-container>
      </div>
      <div class="changes-card">
        <span class="changes-title" i18n>New</span>
        <ng-container *ngIf="hasPersonalChanges$ | async">
          <ng-container *ngFor="let change of (formattedPersonalChanges$ | async)?.new">
            <app-submission-detail
              *ngIf="change.key !== 'socialInsuranceNumber'"
              [label]="change.label"
              [value]="change.value"
              [hasChanged]="change.hasChanged"
              [submissionState]="SubmissionStateEnum.New" />
            <app-sin-submission-detail
              *ngIf="change.key === 'socialInsuranceNumber'"
              label="Social Insurance Number"
              i18n-label
              [value]="change.value"
              [hasChanged]="change.hasChanged"
              [submissionState]="SubmissionStateEnum.New" />
          </ng-container>
        </ng-container>
        <span *ngIf="!(hasPersonalChanges$ | async)" class="not-applicable" i18n>No changes</span>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column gap-3">
    <span class="beneficiary-title mb-0" i18n>Contact Information</span>
    <div class="changes-container">
      <div class="changes-card">
        <span class="changes-title" i18n>Previous</span>
        <ng-container *ngIf="!(formattedContactChanges$ | async | previousNotApplicable); else notApplicable">
          <app-submission-detail
            *ngFor="let change of (formattedContactChanges$ | async)?.previous"
            [label]="change.label"
            [value]="change.value"
            [hasChanged]="change.hasChanged"
            [submissionState]="SubmissionStateEnum.Previous" />
        </ng-container>
      </div>
      <div class="changes-card">
        <span class="changes-title" i18n>New</span>
        <ng-container *ngIf="hasContactChanges$ | async">
          <app-submission-detail
            *ngFor="let change of (formattedContactChanges$ | async)?.new"
            [label]="change.label"
            [value]="change.value"
            [hasChanged]="change.hasChanged"
            [submissionState]="SubmissionStateEnum.New" />
        </ng-container>
        <span *ngIf="!(hasContactChanges$ | async)" class="not-applicable" i18n>No changes</span>
      </div>
    </div>
  </div>
</div>
<ng-template #notApplicable>
  <span class="not-applicable" i18n>Not applicable</span>
</ng-template>
